// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"typography_uk-open__M4gzD","grecaptcha-badge":"typography_grecaptcha-badge__PC2AT","h1":"typography_h1__nvMxn","h2":"typography_h2__3QXx4","h3":"typography_h3__dAEh0","h4":"typography_h4__HNf5a","h5":"typography_h5__bcmsc","h6":"typography_h6__viDko","left":"typography_left__DHyEJ","center":"typography_center__yG0vu","right":"typography_right__EEfHe","justify":"typography_justify__Xp0Oz"};
    if(module.hot) {
      // 1793877040289
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  